import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { connect } from 'react-redux';

import LockScreen from './global/LockScreen';
import Home from './screens/Home';
import Error from './components/Error';
import { fetchContext } from './redux/actions/contextActions';
import { fetchSettings } from './redux/actions/settingsActions';

const AppRoutes = (props) => {
  const { fetchSettings, fetchContext, transitionLockScreen } = props;

  useEffect(() => {
    fetchSettings(() => {
      fetchContext();
    });
  }, []);

  return (
    <>
      <Routes>
        <Route path="/maintenance" element={<Error />} />
        <Route path="/home/*" element={<Home />} />
        <Route path="/" element={<Navigate to="/home" replace />} />
      </Routes>

      {transitionLockScreen && <LockScreen />}
    </>
  );
};

export default connect(
  (state) => ({
    context: state.context,
    transition: state.transition,
    transitionLockScreen: state.transitionLockScreen,
    clientId: state.clientId,
  }),
  { fetchSettings, fetchContext }
)(AppRoutes);
